// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytics-dashboard {
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.analytics-dashboard h2 {
  margin-bottom: 24px;
  color: #2c3e50;
  font-weight: 600;
  text-align: center;
}

.analytics-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  font-size: 18px;
  color: #666;
}

/* Metrics Summary Section */
.metrics-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  

  gap: 20px;
  margin-bottom: 30px;
}

.metric-card {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.2s ease-in-out;
}

.metric-card:hover {
  transform: translateY(-5px);
}

.metric-card h3 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #2c3e50;
  font-size: 16px;
  font-weight: 600;
}

.metric-value {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #2196F3;
}

.metric-detail {
  font-size: 14px;
  color: #7f8c8d;
}

/* Risk Indicators */
.risk-indicators {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.risk-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 12px;
  border-radius: 6px;
  flex: 1 1;
  margin: 0 5px;
  position: relative;
  cursor: help;
}

.risk-indicator.high {
  background-color: rgba(244, 67, 54, 0.1);
}

.risk-indicator.medium {
  background-color: rgba(255, 152, 0, 0.1);
}

.risk-indicator.low {
  background-color: rgba(76, 175, 80, 0.1);
}

.risk-label {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 5px;
}

.risk-indicator.high .risk-label {
  color: #F44336;
}

.risk-indicator.medium .risk-label {
  color: #FF9800;
}

.risk-indicator.low .risk-label {
  color: #4CAF50;
}

.risk-count {
  font-size: 24px;
  font-weight: 700;
}

.risk-indicator.high .risk-count {
  color: #F44336;
}

.risk-indicator.medium .risk-count {
  color: #FF9800;
}

.risk-indicator.low .risk-count {
  color: #4CAF50;
}

/* Tooltip styling */
.risk-tooltip {
  visibility: hidden;
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  text-align: center;
  padding: 8px 12px;
  border-radius: 6px;
  width: 200px;
  font-size: 12px;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s;
  pointer-events: none;
  white-space: normal;
}

.risk-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;
}

.risk-indicator:hover .risk-tooltip {
  visibility: visible;
  opacity: 1;
}

/* Charts Section */
.charts-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.chart-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
  gap: 20px;
}

.chart-card {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.chart-card h3 {
  margin-top: 0;
  margin-bottom: 20px;
  color: #2c3e50;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
}

.chart-container {
  height: 300px;
  position: relative;
}

/* Time Range Selector */
.time-range-selector {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}

.time-range-selector button {
  background-color: #f1f1f1;
  border: none;
  padding: 6px 12px;
  margin: 0 5px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.time-range-selector button:hover {
  background-color: #e0e0e0;
}

.time-range-selector button.active {
  background-color: #2196F3;
  color: white;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .chart-row {
    grid-template-columns: 1fr;
  }
  
  .metrics-summary {
    grid-template-columns: 1fr;
  }
}

/* Age Category Summary */
.age-category-summary {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  margin-top: 20px;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
}

.age-category-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.age-category-label {
  font-weight: 600;
  color: #2c3e50;
}

.age-category-value {
  color: #3498db;
  font-weight: 500;
}

.age-category-percentage {
  color: #7f8c8d;
  font-size: 0.9em;
}

/* Make the chart container a bit taller for the age distribution chart */
.chart-row:last-child .chart-container {
  height: 320px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Adjust the pie chart size to make it more centered and prominent */
.chart-row:last-child .chart-container canvas {
  max-width: 85%;
  max-height: 85%;
  margin: 0 auto;
} `, "",{"version":3,"sources":["webpack://./src/components/AnalyticsDashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,2DAA2D;;;EAG3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,UAAU;EACV,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,oEAAoE;AACtE;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,qEAAqE;AACrE;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB","sourcesContent":[".analytics-dashboard {\n  padding: 20px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.analytics-dashboard h2 {\n  margin-bottom: 24px;\n  color: #2c3e50;\n  font-weight: 600;\n  text-align: center;\n}\n\n.analytics-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n  font-size: 18px;\n  color: #666;\n}\n\n/* Metrics Summary Section */\n.metrics-summary {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  \n\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.metric-card {\n  background-color: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  transition: transform 0.2s ease-in-out;\n}\n\n.metric-card:hover {\n  transform: translateY(-5px);\n}\n\n.metric-card h3 {\n  margin-top: 0;\n  margin-bottom: 15px;\n  color: #2c3e50;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.metric-value {\n  font-size: 36px;\n  font-weight: 700;\n  margin-bottom: 10px;\n  color: #2196F3;\n}\n\n.metric-detail {\n  font-size: 14px;\n  color: #7f8c8d;\n}\n\n/* Risk Indicators */\n.risk-indicators {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n\n.risk-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 8px 12px;\n  border-radius: 6px;\n  flex: 1;\n  margin: 0 5px;\n  position: relative;\n  cursor: help;\n}\n\n.risk-indicator.high {\n  background-color: rgba(244, 67, 54, 0.1);\n}\n\n.risk-indicator.medium {\n  background-color: rgba(255, 152, 0, 0.1);\n}\n\n.risk-indicator.low {\n  background-color: rgba(76, 175, 80, 0.1);\n}\n\n.risk-label {\n  font-size: 12px;\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n\n.risk-indicator.high .risk-label {\n  color: #F44336;\n}\n\n.risk-indicator.medium .risk-label {\n  color: #FF9800;\n}\n\n.risk-indicator.low .risk-label {\n  color: #4CAF50;\n}\n\n.risk-count {\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.risk-indicator.high .risk-count {\n  color: #F44336;\n}\n\n.risk-indicator.medium .risk-count {\n  color: #FF9800;\n}\n\n.risk-indicator.low .risk-count {\n  color: #4CAF50;\n}\n\n/* Tooltip styling */\n.risk-tooltip {\n  visibility: hidden;\n  position: absolute;\n  bottom: 125%;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.8);\n  color: white;\n  text-align: center;\n  padding: 8px 12px;\n  border-radius: 6px;\n  width: 200px;\n  font-size: 12px;\n  z-index: 1;\n  opacity: 0;\n  transition: opacity 0.3s;\n  pointer-events: none;\n  white-space: normal;\n}\n\n.risk-tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;\n}\n\n.risk-indicator:hover .risk-tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n\n/* Charts Section */\n.charts-container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.chart-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));\n  gap: 20px;\n}\n\n.chart-card {\n  background-color: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.chart-card h3 {\n  margin-top: 0;\n  margin-bottom: 20px;\n  color: #2c3e50;\n  font-size: 16px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.chart-container {\n  height: 300px;\n  position: relative;\n}\n\n/* Time Range Selector */\n.time-range-selector {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 15px;\n}\n\n.time-range-selector button {\n  background-color: #f1f1f1;\n  border: none;\n  padding: 6px 12px;\n  margin: 0 5px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s;\n}\n\n.time-range-selector button:hover {\n  background-color: #e0e0e0;\n}\n\n.time-range-selector button.active {\n  background-color: #2196F3;\n  color: white;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .chart-row {\n    grid-template-columns: 1fr;\n  }\n  \n  .metrics-summary {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Age Category Summary */\n.age-category-summary {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 16px;\n  margin-top: 20px;\n  padding: 10px;\n  background-color: rgba(0, 0, 0, 0.02);\n  border-radius: 8px;\n}\n\n.age-category-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background-color: white;\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.age-category-label {\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.age-category-value {\n  color: #3498db;\n  font-weight: 500;\n}\n\n.age-category-percentage {\n  color: #7f8c8d;\n  font-size: 0.9em;\n}\n\n/* Make the chart container a bit taller for the age distribution chart */\n.chart-row:last-child .chart-container {\n  height: 320px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Adjust the pie chart size to make it more centered and prominent */\n.chart-row:last-child .chart-container canvas {\n  max-width: 85%;\n  max-height: 85%;\n  margin: 0 auto;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
